exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".returns-header {\n  display: flex;\n  justify-content: space-between;\n  padding: 40px 0;\n}\n@media screen and (max-width: 768px) and (min-width: 320px) {\n.returns-header {\n    padding: 25px 0;\n}\n}\n@media screen and (max-width: 480px) and (min-width: 320px) {\n.returns-header {\n    flex-direction: column;\n    padding: 25px 30px;\n}\n.returns-header h1 {\n    text-align: center;\n    margin-bottom: 15px;\n}\n}\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n.ipad-portrait {\n    padding: 10px 20px !important;\n}\n}", ""]);

// exports
